import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required , typeInteger, typeIntegerOrDecimal, typeIntegerOrDecimalOr0, typeIntegerOrDecimalMin10} from "../../common/Validations";
import { 
  Container, 
  Box, 
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  IconButton,
  InputLabel,
  Grid,
  Paper,
  Typography, 
  Tooltip,
  Input,
  InputAdornment,
  Icon,
  Toolbar,
  MenuItem
} from "@material-ui/core"
import ColorField from "../../components/ColorField/ColorField"
import IconPicker from "../../components/IconPicker/IconPicker"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import ImageSelector from '../../components/ImageSelector/ImageSelector'
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import { actionSaveCategory } from '../../actions/RestaurantActions'
let _handleSubmitFail;
class AddEditMenuCategory extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={imgEdit:null, imgNameEdit:null, imgError:""}
    this.onClean=this.onClean.bind(this)
    this.onSave=this.onSave.bind(this)
    this.onSelectImage=this.onSelectImage.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    if(this.props.isEditing){
      let category=this.props.history.location.state
      // ticket.tktInitDate = ticket.tktInitDate&&Util.timestampToMoment(ticket.tktInitDate).format('YYYY-MM-DDTHH:mm') 
      // ticket.tktEndDate = ticket.tktEndDate&&Util.timestampToMoment(ticket.tktEndDate).format('YYYY-MM-DDTHH:mm')
      this.props.initialize(category)
      this.setState({imgEdit:category.catImg, imgNameEdit:category.catImgName})
    }else{
      this.props.initialize()
    }
  }
  
  handleSubmitFail(error){
    if(error.catImg){ 
      this.setState({imgError:error.mnuImg})
    }
    console.log("ERROR EN EL SUBMIT", error)
  }

  onSelectImage(imgUrl, imgBlob, fileName){
    this.props.change("catImg", {blob:imgBlob}) //No me deja setear el blob así que lo paso como un objeto con un blob
    this.props.change("catImgName", fileName)
    this.setState({imgEdit:imgUrl, imgNameEdit:fileName})
  }

  onClean(){
    this.setState({imgEdit:null, imgNameEdit:null, imgError:""})
    if(this.props.isEditing){
      let category=this.props.history.location.state
      this.props.initialize({id:category.id, catImgPath:category.catImgPath})
    }else{
      this.props.initialize()
    }
  }

  onSave(formValues){
    let canSave = true
    if(!this.props.isEditing){
      const existIdx = this.props.categoryList.findIndex((c)=>{return c.id==formValues.id})
      if(existIdx>=0){
        Util.showNoty(ERROR, "Ya existe una categoría con el nombre ingresado.")
        canSave=false
      }
    }
    let orderIdx = this.props.categoryList.findIndex((c)=>{return c.id!=formValues.id&&c.catOrder==formValues.catOrder})
    if(orderIdx>=0){
      Util.showNoty(ERROR, "Ya existe una categoría con el número de orden ingresado.")
      canSave=false
    }
    if(canSave){
      this.props.actionSaveCategory(formValues
        , ()=>{Util.showNoty(SUCCESS, "La categoría se guardó correctamente."); this.props.history.goBack()}
        , (e)=>{
          console.log("ERROR ON SAVE TICKET", e)
          if(!(e&&e.status&&e.status==401))
            Util.showNoty(ERROR, e.statusText||"No se pudo guardar la categoría.")
        }
      )
    }
  }

  render(){
    const { theme, handleSubmit, restaurant, isEditing } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <Tooltip title="Atrás">
              <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
                <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
              </IconButton>
            </Tooltip>  
          </Box>
          <Box>
            <Typography variant="h1">{restaurant&&restaurant.evtName}</Typography>
            <Typography variant="subtitle1">Crea categoría de menú</Typography>
          </Box>
        </Box>
        <Container>        
          <Paper >
            <Box style={theme.paper.addEditTicketTypeTitle}>
              <Typography style={theme.paper.title} variant="h2">Crear categoría de menú</Typography>
            </Box>            
            <form style={theme.paper.form}>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <Field
                      component={TextField}
                      name="catOrder"
                      label="Nro. de Orden"
                      format={Util.formatNumber}
                      parse={Util.toNumber}
                      InputLabelProps={{ shrink: true }}
                      validate={[required, typeInteger]}
                    />
                </Grid>
                <Grid item xs={8}>
                  <Field
                    component={TextField}
                    disabled={isEditing}
                    name="id"
                    label="Nombre de la categoría"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={2}>
                <Tooltip title="Subí la imagen en 64x64">
                  <FormControl fullWidth error={this.state.imgError?true:false}>
                    <ImageSelector
                      fieldName="catImg"
                      // validate={[required]}
                      showDelete
                      fileDimentions={{ width: 64, height: 64 }}
                      styleButton={{...theme.imageSelector, width: 64, height: 64}}
                      imagePreviewUrl={this.state.imgEdit}
                      fileName={this.state.imgNameEdit}
                      maxWidth={64}
                      maxHeight={64}
                      fileSize={400000}
                      noPreview
                      onChangeState={()=>{this.setState({imgError:""})}}
                      crop={{
                        // aspect: 64/64,
                        x: 0,
                        y: 0,
                        width: 64,
                        height: 64,
                        // unit:"px"
                      }}
                      onSelect={this.onSelectImage}
                      hideInfo
                    />
                    <FormHelperText>{this.state.imgError}</FormHelperText>
                  </FormControl>
                  </Tooltip>
                </Grid>
              </Grid>
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.onClean}>Limpiar</Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.props.history.goBack}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button variant="contained" color="primary" style={theme.footer.button} onClick={handleSubmit(this.onSave)}>Guardar</Button>
            </Tooltip>                  
          </Toolbar>
        </Container>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  // console.log("STORE", store)
  return {
    login: store.auth.login,
    restaurant: store.evt.restaurant,
    categoryList: store.evt.categoryList,

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionSaveCategory
    },
    dispatch
  );
}

export default  reduxForm({
  form: "addEditTicketType",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AddEditMenuCategory)
    )
  )
)


// WEBPACK FOOTER //
// ./src/screens/restaurants/AddEditMenuCategory.js